const { useState } = wp.element;
const { RichText } = wp.blockEditor;

const EditCol = ({ line, col, attributes, setAttributes }) => {
  const { content } = attributes;

  const [text, setText] = useState(content[line]?.columns[col] || '');

  const changeText = (text) => {
    const newContent = content.map((item, index) => {
      if (index === line) {
        item.columns[col] = text;
      }

      return item;
    });

    setAttributes({ content: newContent });
    setText(text);
  };

  const tag = col === 0 ? 'h3' : 'p';
  const variant = 'text';
  const position = col === 0 ? 'left' : 'center';

  return (
    <td>
      <RichText
        tagName={tag}
        selector={tag}
        className={`Typography ${variant} ${position} color-black margin-none`}
        value={text}
        placeholder="Texto (tag p)"
        keepPlaceholderOnFocus
        onChange={(val) => changeText(val)}
      />
    </td>
  );
};

export default EditCol;
